import React from "react";
import { useNavigate } from "react-router-dom";
import './responseMessage.css';

const Pending = () => {
  const navigate = useNavigate();

  return (
    <div className="response-container pending">
      <h2>Pago pendiente ⏳</h2>
      <p>Tu pago está siendo procesado. Te notificaremos cuando se confirme.</p>
      <button className="response-btn" onClick={() => navigate('/')}>Volver al inicio</button>
    </div>
  );
};

export default Pending;
